export default {
    BOOKING_SERVER_BASE_URL :process.env.REACT_APP_BOOKING_API_BASE_URL,
    USERS_SERVER_BASE_URL   :process.env.REACT_APP_USERS_API_BASE_URL,
    BOOKING_API_POSIX       :"/api/v1/",
    USERS_API_POSIX         :"/api/v1/users/",
    USERS_DEVICE_POSIX      :"/api/v1/devices/",
    USERS_TENANT_POSIX      :"/api/v1/tenants/",
    USERS_TENANT_V2_POSIX   :"/api/v2/tenants/",
    MOBILE_API_V2_POSIX     :"/api/v2/mobile/"
}